import { render, staticRenderFns } from "./MachineCreateUpdate.vue?vue&type=template&id=0b48a27f&"
import script from "./MachineCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./MachineCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports